module.exports = __webpack_public_path__ + "static/media/404.083ce93e.png";